import classnames from 'classnames';
import { useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';
import { prettyDate } from '@/helpers/date';
import { Checkbox } from '@/webkit/form/Checkbox';
import { useGetCashMovementsList } from '@/query/queries/activity/useGetCashMovementsList';
import { FilterViewDesktop } from './desktop';
import s from './index.module.scss';

export const Filters = props => {
  const { params, setParams } = props;
  const { type: accountType } = useOutletContext();
  const { t } = useTranslation('activity');

  const { data } = useGetCashMovementsList({
    page: params.page,
    date_from: params.range[0],
    date_to: params.range[1],
    operation_types: params.operation_types,
    grouping: JSON.stringify(params.grouping),
    type: accountType,
  });

  const onFilterChange = (key, value) => {
    setParams(prev => ({ ...prev, page: 1, [key]: value }));
  };

  return (
    <div className={s.wrapper}>
      <FilterViewDesktop {...props} onFilterChange={onFilterChange} />
      <div className={s.footer}>
        <div className={s.left}>
          <div className="f-small-regular">
            {t('cash_filters.cash_movements', {
              from: prettyDate(params.range[0], 'DD MMMM YYYY'),
              to: prettyDate(params.range[1], 'DD MMMM YYYY'),
            })}
          </div>
          {data && (
            <div className="f-small-regular" style={{ color: '#52626F' }}>
              {t('cash_filters.opening_balance', {
                date: prettyDate(params.range[0], 'DD MMMM YYYY'),
                amount: prettyFloatMoney(data.opening_balance),
              })}
            </div>
          )}
        </div>
        <Checkbox
          name="grouping"
          checked={params.grouping}
          onChange={() =>
            setParams(prev => ({
              ...prev,
              page: 1,
              grouping: !params.grouping,
            }))
          }
        >
          <span className={classnames(s.grouping, 'f-small-regular')}>
            {t('cash_filters.group_by_operation')}
          </span>
        </Checkbox>
      </div>
    </div>
  );
};
